import type { Theme } from "../../../types";

// New themes
import cercle from "./assets/cercle.png";
import coeur from "./assets/coeur.png";
import octogone from "./assets/octogone.png";
import nuage from "./assets/nuage.png";
import losange from "./assets/losange.png";

import cercleMask from "./assets/cercle-mask.png";
import coeurMask from "./assets/coeur-mask.png";
import octogoneMask from "./assets/octogone-mask.png";
import nuageMask from "./assets/nuage-mask.png";
import losangeMask from "./assets/losange-mask.png";

// Old themes (kept for backward compatibility)
import love from "./assets/love.png";
import birthday from "./assets/birthday.png";
import family from "./assets/family.png";
import baby from "./assets/baby.png";
import beach from "./assets/beach.png";

import loveMask from "./assets/love-mask.png";
import birthdayMask from "./assets/birthday-mask.png";
import familyMask from "./assets/family-mask.png";
import babyMask from "./assets/baby-mask.png";
import beachMask from "./assets/beach-mask.png";

const themes: Theme[] = [
  // New themes (visible in UI)
  {
    value: "cercle",
    label: "Cercle",
    src: cercle,
    top: "85%",
    color: "#ffc107",
    mask: cercleMask,
  },
  {
    value: "coeur",
    label: "Coeur",
    src: coeur,
    top: "10%",
    color: "#f44336",
    mask: coeurMask,
  },
  {
    value: "octogone",
    label: "Octogone",
    src: octogone,
    top: "8%",
    color: "#9c27b0",
    mask: octogoneMask,
  },
  {
    value: "nuage",
    label: "Nuage",
    src: nuage,
    top: "13%",
    color: "#00bcd4",
    mask: nuageMask,
  },
  {
    value: "losange",
    label: "Losange",
    src: losange,
    top: "85%",
    color: "#ff9800",
    mask: losangeMask,
  },
  // Old themes (hidden, kept for backward compatibility)
  {
    value: "love",
    label: "Amour",
    src: love,
    top: "17%",
    color: "#f44336",
    mask: loveMask,
    hidden: true,
  },
  {
    value: "birthday",
    label: "Anniversaire",
    src: birthday,
    top: "85%",
    color: "#ffc107",
    mask: birthdayMask,
    hidden: true,
  },
  {
    value: "family",
    label: "Famille",
    src: family,
    top: "10%",
    color: "#9c27b0",
    mask: familyMask,
    hidden: true,
  },
  {
    value: "baby",
    label: "Bébé",
    src: baby,
    top: "17%",
    color: "#00bcd4",
    mask: babyMask,
    hidden: true,
  },
  {
    value: "beach",
    label: "Plage",
    src: beach,
    top: "85%",
    color: "#ff9800",
    mask: beachMask,
    hidden: true,
  },
];

export default themes;
